import { Box, Tooltip } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { UNMATCHED_FILE_STATUS } from 'src/utils/enums/unmatchedFileStatus';

// A file can drift out of sync with the deployed catalog in two directions: trusted but not yet
// cataloged, or removed from trust while still sitting in the last generated catalog.
export const getCatalogTrustWarning = (trustStatus, trustedAsOfVersion) => {
  if (trustStatus === UNMATCHED_FILE_STATUS.Trusted && !trustedAsOfVersion) {
    return 'Trusted, but not in a security catalog yet — generate or update a catalog to include it.';
  }
  if (trustedAsOfVersion && trustStatus !== UNMATCHED_FILE_STATUS.Trusted) {
    return `Still in the deployed catalog (${trustedAsOfVersion}) but no longer trusted — regenerate the catalog to remove it.`;
  }
  return null;
};

const CatalogTrustWarning = ({
  trustStatus,
  trustedAsOfVersion,
  width = 15,
  height = 15,
  noTooltip = false,
}) => {
  const message = getCatalogTrustWarning(trustStatus, trustedAsOfVersion);
  if (!message) {
    return null;
  }
  const icon = (
    <Box component="span" display="inline-flex" alignItems="center">
      <Iconify icon="mdi:alert-outline" width={width} height={height} color="#E0A23C" />
    </Box>
  );
  if (noTooltip) {
    return icon;
  }
  return (
    <Tooltip
      title={message}
      arrow
      componentsProps={{ tooltip: { sx: { bgcolor: '#3F3F3F', maxWidth: 320 } } }}>
      {icon}
    </Tooltip>
  );
};

export default CatalogTrustWarning;
